import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppSettingsState } from 'src/app/models/state/app-settings-state.model';

export const selectAppSettingsState =
	createFeatureSelector<AppSettingsState>('appSettings');

export const selectIsGeolocationEnabled = createSelector(
	selectAppSettingsState,
	appSettingState => appSettingState.isGeolocationEnabled
);
